import { render, staticRenderFns } from "./paymentStatus.vue?vue&type=template&id=e7284a2c&"
import script from "./paymentStatus.vue?vue&type=script&lang=js&"
export * from "./paymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports